<div id="main" class="pl-0 pr-0 ml-0 mr-0">
  <!-- RaspberryAI platform: use dedicated RAI header with integrated left nav -->
  <ng-container *ngIf="isRaspberryAI; else defaultHeader">
    <medpt-rai-header>
      <medpt-body [isRaiLayout]="true"></medpt-body>
    </medpt-rai-header>
  </ng-container>

  <!-- Default platform header -->
  <ng-template #defaultHeader>
    <medpt-header></medpt-header>
    <medpt-body></medpt-body>
  </ng-template>
</div>
<medpt-footer></medpt-footer>
